import type { FaireProductEntity } from "../../entity_types/product";

export const p_gapng3nshg: FaireProductEntity = {
  token: "p_gapng3nshg",
  type: "product",
  name: "Sis Knit Sweater, Lavender",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/0adfb8e3521484ee7b4e14b5a1edbae587f5e47f52dd6bdddebcb702d2544873.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed1e581b1a55f3fb9f28213736dd61d2670c544f690f471b86f4f35615ce313e.jpeg",
    "https://cdn.faire.com/fastly/a7424d45474334387b8cbf2b6378452d4f8236c7c4910819341bb693b23f73fe.jpeg",
  ],
  priceDollars: 21,
  description:
    "\nFor the sweetest Sister! These cozy knit sweaters are perfectly oversized and made from 100% sheep wool. \n\n * Made from 100% Sheep Wool \n * Imported \nCARE INSTRUCTIONS\n\nWashing: hand wash recommended\nDry cleaning: do not dry clean\nBleaching: do not bleach\nDrying: hang dry\n",
  tags: [],
  msrpDollars: 42,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:09.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
